/* eslint-disable no-multi-assign */
/* eslint-disable prettier/prettier */

/**
 * This file is auto-generated by the build/release process.
 * DO NOT MODIFY.
 */
const releaseName = 'zmyle-www-ui:20251107151058:master:d51ae96a7206be6b757248efd2b799b7df3d7be8';
const dirname = __dirname;

exports = module.exports = (() => {
  const data = releaseName.split(':');
  if (data.length !== 4) {
    throw Error(
      `No proper release info generated during build phase: '${releaseName}'`,
    );
  }
  return {
    name: String(data[0]),
    gitBranch: String(data[2]),
    gitCommit: String(data[3]),
    releasedAt: `${data[1]} +0000`,
    release: releaseName,
    __projectRootDirname: dirname,
  };
})();
